import {NameValueDTO} from 'src/app/modules/common/models/NameValueDTO';
import {BaseDTO} from '../../common/models/BaseDTO';

export class DrugInteractionCategoryDTO extends BaseDTO {
  drugInteractionCategoryId: number;
  name: string;
  synonym: string;

  atcCodes: NameValueDTO[];
}
